module.exports = __webpack_public_path__ + "img/donation-after-4.6b731e17.png";